import { ProcessStatusTableDto } from "@intelligems/ig-types/dtos/processes";
import { createSlice } from "@reduxjs/toolkit";
import { IProcessesSliceState } from "@src/store/slices/processes/types";

const initialState: IProcessesSliceState = {
  processes: [],
};

const slice = createSlice({
  name: "processes",
  initialState,
  reducers: (create) => ({
    setProcesses: create.reducer<ProcessStatusTableDto[]>((state, action) => {
      state.processes = action.payload ?? [];
    }),
  }),
  selectors: {
    getProcesses: (state) => state.processes,
    getProcessMap: (state) =>
      state.processes.reduce(
        (map, process) => {
          map[process.id] = process;
          return map;
        },
        {} as Record<string, ProcessStatusTableDto>
      ),
  },
});

export const processesReducer = slice.reducer;

export const { setProcesses } = slice.actions;
export const { getProcesses, getProcessMap } = slice.selectors;
